import React from 'react';
import propTypes from 'prop-types';

import { navBtnPropTypes } from '../Detail/DetailPropTypes';
import { residencePropTypesData } from '../../utils/DrupalEntityTypes/Residence/ResidencePropTypes';
import useDetailViewTracking from '../../hooks/useDetailViewTracking';

import FadingContainer from '../FadingContainer/FadingContainer';
import DetailDialog from '../Detail/DetailDialog';
import DetailTable from '../Detail/DetailTable';
import FloorPlanDetailCore from '../FloorPlan/FloorPlanDetailCore';
import useResidenceDetail from './useResidenceDetail';
import PibResidenceHeader from './PibResidenceHeader';
import PibResidenceMapSection from './PibResidenceMapSection';

/**
 * PibResidenceDetail - Residence detail for the PIB page.
 * Includes internal header and embedded map section.
 */
const PibResidenceDetail = ({
  data,
  uuid,
  navBtns,
  navClass,
  trackPibViews,
}) => {
  useDetailViewTracking({
    type: 'unit',
    nid: data?.nid,
    enabled: trackPibViews,
  });

  // Get shared residence detail data from hook
  const {
    unitData,
    isDataLoaded,
    title,
    description,
    svgId,
    hasFees,
    tableInfo,
    detailDialogData,
    pricingTriggered,
    setPricingTriggered,
    platformShowPricing,
    platformShowPricingInitially,
  } = useResidenceDetail(uuid, data);

  return (
    <FadingContainer>
      <div>
        <DetailDialog detailDialogData={detailDialogData} />

        <PibResidenceHeader
          unitData={unitData}
          title={title}
          isDataLoaded={isDataLoaded}
          navBtns={navBtns}
          navClass={navClass}
          hasFees={hasFees}
          pricingTriggered={pricingTriggered}
          platformShowPricing={platformShowPricing}
          platformShowPricingInitially={platformShowPricingInitially}
          setPricingTriggered={setPricingTriggered}
        />

        <DetailTable
          id="info-scroll"
          listData={tableInfo}
          tableDescription={description}
          className="detailSection"
        />

        <FloorPlanDetailCore
          data={unitData}
          minimalData={data}
          isLoadingPhotoGallery={!unitData}
          isLoadingVideo={!unitData}
          isLoadingVirtualTour={!unitData}
          parent="page"
          contentType="residence"
        />

        {unitData && svgId ? (
          <PibResidenceMapSection svgId={svgId} />
        ) : null}
      </div>
    </FadingContainer>
  );
};

PibResidenceDetail.propTypes = {
  uuid: propTypes.string,
  data: residencePropTypesData,
  navBtns: navBtnPropTypes,
  navClass: propTypes.string,
  trackPibViews: propTypes.bool,
};

PibResidenceDetail.defaultProps = {
  uuid: null,
  data: null,
  navBtns: null,
  navClass: null,
  trackPibViews: false,
};

export default PibResidenceDetail;
